import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './firebase'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueGtag from "vue-gtag";
import VueResource from 'vue-resource';

import './assets/scss/app.scss'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "aos/dist/aos.css";

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueResource)

let app
auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app')
    }

    if (user) {
        store.dispatch('fetchUserProfile', user)
    }
})

Vue.use(VueGtag, {
    config: { id: "G-MCM4CJEJDH" }
}, router);